import { Component } from "react";
import TopNav from "../components/top_nav";
import Footer from "../components/footer";
import { ArrowRight } from 'react-bootstrap-icons';



const positions = [
    {
        type: "Full-time",
        location: "On-site (Mukio HQ)",
        title: "Mergers & Acquisitions Consultant",
        description:
            "The M&A Consultant will lead and advise on business mergers, acquisitions, and corporate restructuring.",
    },
    {
        type: "Full-time",
        location: "On-site (Mukio HQ)",
        title: "Mergers & Acquisitions Consultant",
        description:
            "The M&A Consultant will lead and advise on business mergers, acquisitions, and corporate restructuring.",
    },
    {
        type: "Full-time",
        location: "On-site (Mukio HQ)",
        title: "Mergers & Acquisitions Consultant",
        description:
            "The M&A Consultant will lead and advise on business mergers, acquisitions, and corporate restructuring.",
    },
];



const teamMembers = [
    {
        name: "David Lee",
        title: "Head of Business Strategy",
        description:
            "An expert in business optimization, David works closely with clients to streamline operations and enhance profitability through tailored solutions.",
        image: "Team.webp", // Replace with actual image
        linkedin: "https://www.linkedin.com"
    },
    {
        name: "David Lee Copy 2",
        title: "Head of Business Strategy",
        description:
            "An expert in business optimization, David works closely with clients to streamline operations and enhance profitability through tailored solutions.",
        image: "Team.webp",
        linkedin: "https://www.linkedin.com"
    },
    {
        name: "David Lee Copy 2",
        title: "Head of Business Strategy",
        description:
            "An expert in business optimization, David works closely with clients to streamline operations and enhance profitability through tailored solutions.",
        image: "Team.webp",
        linkedin: "https://www.linkedin.com"
    },
    {
        name: "David Lee Copy 2",
        title: "Head of Business Strategy",
        description:
            "An expert in business optimization, David works closely with clients to streamline operations and enhance profitability through tailored solutions.",
        image: "Team.webp",
        linkedin: "https://www.linkedin.com"
    },
    {
        name: "David Lee Copy 2",
        title: "Head of Business Strategy",
        description:
            "An expert in business optimization, David works closely with clients to streamline operations and enhance profitability through tailored solutions.",
        image: "Team.webp",
        linkedin: "https://www.linkedin.com"
    },
    {
        name: "David Lee Copy 2",
        title: "Head of Business Strategy",
        description:
            "An expert in business optimization, David works closely with clients to streamline operations and enhance profitability through tailored solutions.",
        image: "Team.webp",
        linkedin: "https://www.linkedin.com"
    },

    // Add more members as needed
];




export default class AboutScreen extends Component {
    render() {
        return (
            <div>
                <TopNav />

                <div className="row mx-0 justify-content-center">
                    <div className="col-10 px-0">
                        <div>
                            <p className="mt-5 fs-52 fw-bold">Engineering the Future of Railways,<br />
                                One Innovation at a Time</p>
                            <p className="fs-16">
                                At BHEPL, we are not just technology providers — we are railway technocrats,
                                problem-solvers, and visionaries. With over four decades of collective experience
                                in designing, deploying, and modernizing advanced rail systems, our team brings
                                unmatched domain expertise and deep industry insights to every project.
                            </p>
                            <p className="fs-16 mt-2">
                                We specialize in cutting-edge technological solutions tailored for the
                                evolving challenges of modern rail networks — combining advanced R&D,
                                real-world customizations, and deep system integration to deliver impactful results.
                            </p>
                            <div className="">
                                <img
                                    src="/about.avif"
                                    alt="About"
                                    className="img-fluid w-100 rounded-4"
                                    style={{ objectFit: "", maxHeight: "135vh" }}
                                />
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-md-11">
                                    <p className="fs-42 fw-bold mt-5">What we do</p>
                                    <p className="fs-18 mt-2">
                                        From digital twins and EULYNX-compliant systems to LiDAR-based surveys,
                                        AI-driven yard safety, and design automation — we create smart, scalable,
                                        and future-proof technologies that drive railway transformation from the
                                        ground up.
                                    </p>
                                    <p className="fs-18 mt-2">
                                        Our innovations are not built in silos — they’re forged in the field,
                                        co-created with clients, and rigorously tested in real-world rail environments.
                                    </p>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-md-11">
                                    <p className="fs-42 fw-bold mt-5">Our Vision</p>
                                    <p className="fs-18 mt-2">
                                        To be the go-to innovation partner for railway organizations worldwide,
                                        enabling safer, smarter, and more sustainable rail ecosystems through
                                        transformative technology.
                                    </p>
                                </div>
                            </div>



                            <div class="container my-5">
                                <div class="row g-4 align-items-center bg-primary-blue rounded-4">
                                    <div class="col-md-6">
                                        <div class="text-white p-4 h-100">
                                            <h2 class="fw-bold mb-4 fs-36">What Sets Us Apart</h2>

                                            <div class="d-flex mb-3">
                                                <div class="me-3">
                                                    <i className="bi bi-check-circle-fill fs-24"></i>
                                                </div>
                                                <div>
                                                    <h6 class="fw-semibold mb-1 fs-20">Deep Technical DNA</h6>
                                                    <p class="mb-0 fs-16">Our solutions are built by technologists who live and breathe rail systems.</p>
                                                </div>
                                            </div>

                                            <div class="d-flex mb-3">
                                                <div class="me-3">
                                                    <i className="bi bi-check-circle-fill fs-24"></i>
                                                </div>
                                                <div>
                                                    <h6 class="fw-semibold mb-1 fs-20">Customization at Core</h6>
                                                    <p class="mb-0 fs-16">No one-size-fits-all. Every solution is tailored to your context, geography, and legacy systems.</p>
                                                </div>
                                            </div>

                                            <div class="d-flex mb-3">
                                                <div class="me-3">
                                                    <i className="bi bi-check-circle-fill fs-24"></i>
                                                </div>
                                                <div>
                                                    <h6 class="fw-semibold mb-1 fs-20">High-End R&D</h6>
                                                    <p class="mb-0 fs-16">In-house labs and continuous innovation pipelines fuel every product we deliver.</p>
                                                </div>
                                            </div>

                                            <div class="d-flex mb-3">
                                                <div class="me-3">
                                                    <i className="bi bi-check-circle-fill fs-24"></i>
                                                </div>
                                                <div>
                                                    <h6 class="fw-semibold mb-1 fs-20">Built for Real-World Problems</h6>
                                                    <p class="mb-0 fs-16">Designed not just to function, but to perform under the pressures of live railway operations.</p>
                                                </div>
                                            </div>

                                            <div class="d-flex mb-4">
                                                <div class="me-3">
                                                    <i className="bi bi-check-circle-fill fs-24"></i>
                                                </div>
                                                <div>
                                                    <h6 class="fw-semibold mb-1 fs-20">End-to-End Capability</h6>
                                                    <p class="mb-0 fs-16">From requirements engineering to design, build, integration, and support.</p>
                                                </div>
                                            </div>

                                            <button
                                                onClick={() => window.location.href = "solutions"}
                                                className="btn d-flex align-items-center px-1 py-1 rounded-pill text-primary-blue bg-white mt-2"
                                            >
                                                <span className="mx-3">Explore Our Solutions</span>
                                                <div
                                                    className="d-flex justify-content-center align-items-center rounded-circle bg-primary-blue"
                                                    style={{
                                                        width: '32px',
                                                        height: '32px',
                                                    }}
                                                >
                                                    <ArrowRight color="#FFFFFF" />
                                                </div>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="col-md-6 mb-4 pe-4">
                                        <img
                                            src="about1.webp"
                                            alt="Team working"
                                            className="img-fluid w-100 rounded-4 border border-1 border-white"
                                            style={{ objectFit: "cover", maxHeight: "590px" }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ height: "40px" }}></div>
                            <div className="row pt-5 bg-grey-color">
                                <div className="col-md-6">
                                    <h6 className="fs-20 text-primary-blue fw-bold">Meet Our Team</h6>
                                    <p className="fs-32 fw-bold mb-1">Let’s Build the Railways of Tomorrow</p>
                                    <p className="fs-18">
                                        Whether you’re modernizing legacy infrastructure or pioneering new corridors,
                                        BHEPL is your trusted technology ally. Together, let’s shape the intelligent
                                    </p>
                                    <button
                                        onClick={() => window.location.href = "contact"}
                                        className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white bg-primary-blue"
                                    >
                                        <span className="mx-3 fs-14">Contact us for Strategic Collaboration</span>
                                        <div
                                            className="d-flex justify-content-center align-items-center rounded-circle"
                                            style={{
                                                width: '35px',
                                                height: '35px',
                                                backgroundColor: '#ffffff',
                                            }}
                                        >
                                            <ArrowRight color="#193E6C" />
                                        </div>
                                    </button>
                                </div>

                                <div className="col-md-6 d-flex align-items-stretch mt-4 mt-md-0">
                                    <img
                                        src="/discuss2.webp"
                                        alt="Discuss"
                                        className="img-fluid rounded-4 shadow-sm w-100"
                                        style={{ objectFit: 'cover', height: '280px' }}
                                    />
                                </div>
                            </div>









                            {/* <div className="row justify-content-center">
                                <div className="col-md-8 text-center">
                                    <p className="fs-42 fw-bold mt-5 fst-italic">People Behind the Tech.</p>
                                    <p className="fs-18 mt-2">
                                        Our core strength lies in our people — a passionate, agile team of engineers,
                                        system architects, R&D scientists, and railway domain experts.
                                    </p>
                                </div>
                            </div>



                            <div className="container my-5">
                                <div className="row">
                                    {teamMembers.map((member, idx) => (
                                        <div className="col-md-6 col-lg-3 px-0" key={idx}>
                                            <div className="position-relative overflow-hidden rounded shadow-sm team-card p-2" style={{ height: '350px' }}>
                                                <img
                                                    src={member.image}
                                                    className="w-100 h-100 object-fit-cover rounded"
                                                    alt={member.name}
                                                    style={{ objectFit: 'cover' }}
                                                />

                                                <div
                                                    className="position-absolute bottom-0 start-0 w-100 p-3">
                                                    <a
                                                        href={member.linkedin}
                                                        className="fw-1000 mb-2 d-flex align-items-center justify-content-center bg-dark text-white rounded-circle text-decoration-none"
                                                        style={{ width: '40px', height: '40px' }}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <img src="https://framerusercontent.com/images/pC32L6j5QOm1Ihk4pR2eWPcqnc.svg" className="w-50 h-50" />
                                                    </a>
                                                    <div className="bg-white p-2 rounded-3">
                                                        <h5 className="fs-16 fw-bold">{member.name}</h5>
                                                        <p className="mb-1 fs-12">{member.title}</p>
                                                        <p className="mb-0 fs-10 team-description">{member.description}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>


                            <div className="d-flex justify-content-between align-items-center">
                                <p className="fs-28 fw-semibold mb-0">Join Our Team and Build a Successful Career</p>
                                <div>
                                    <button
                                        onClick={() => window.location.href = "about"}
                                        className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white bg-primary-blue"
                                    >
                                        <span className="mx-3 fs-14">Browse all positions</span>
                                        <div
                                            className="d-flex justify-content-center align-items-center rounded-circle"
                                            style={{
                                                width: '35px',
                                                height: '35px',
                                                backgroundColor: '#ffffff',
                                            }}
                                        >
                                            <ArrowRight color="#193E6C" />
                                        </div>
                                    </button>

                                </div>
                            </div>

                            <div className="row mt-4">
                                {positions.slice(0, 3).map((job, index) => (
                                    <div className="col-md-4 mb-4" key={index}>
                                        <div className="  rounded-4 p-4 h-100 shadow-sm">
                                            <div className="mb-3">
                                                <span className="badge   text-dark border me-2 px-3 py-1 rounded-pill fs-14">
                                                    {job.type}
                                                </span>
                                                <span className="badge   text-dark border px-3 py-1 rounded-pill fs-14">
                                                    {job.location}
                                                </span>
                                            </div>
                                            <h5 className="fs-18 fw-bold">{job.title}</h5>
                                            <p className="fs-14">{job.description}</p>
                                            <button
                                                onClick={() => window.location.href = "about"}
                                                className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-3 bg-primary-blue"
                                            >
                                                <span className="mx-3 fs-14">Apply now</span>
                                                <div
                                                    className="d-flex justify-content-center align-items-center rounded-circle"
                                                    style={{
                                                        width: '35px',
                                                        height: '35px',
                                                        backgroundColor: '#ffffff',
                                                    }}
                                                >
                                                    <ArrowRight color="#193E6C" />
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div> */}






                        </div>
                    </div>
                </div>

                <div style={{ height: "80px" }}></div>

                <Footer />
            </div>
        );
    }
}
